import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box } from '@mantine/core'
import { NavMenuBar } from '@/components/Elements'
import { useUsersData } from '@/features/users/hooks'
import { PATH, PATH_ADMIN, PATH_ADMIN_USERS, PATH_ADMIN_USERS_EDIT } from '@/routes/consts'

const TABS_KEY = {
  PROFILE: 'profile',
  SECURITY: 'security',
}

const { PROFILE, SECURITY } = TABS_KEY

export const Tabs = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const location = useLocation()

  const { user } = useUsersData({})

  const basePath = `/${PATH.ADMIN}/${PATH_ADMIN.USERS}/${user?.id}/${PATH_ADMIN_USERS.EDIT}`

  const TABS_CONFIG = {
    [PROFILE]: {
      label: t('personal_data'),
      value: PROFILE,
      path: `${basePath}/${PATH_ADMIN_USERS_EDIT.PROFILE}`,
    },
    [SECURITY]: {
      label: t('confidential_info'),
      value: SECURITY,
      path: `${basePath}/${PATH_ADMIN_USERS_EDIT.SECURITY}`,
    },
  }

  const tabsConfigValues = Object.values(TABS_CONFIG)

  const tabs = useMemo(() => {
    return tabsConfigValues.map(({ label, value }) => ({
      label,
      value,
    }))
  }, [])

  const onTabChange = (value: string) => {
    const tabConfig = TABS_CONFIG[value]

    navigate(`${tabConfig?.path}`)
  }

  const tabsValue = useMemo(() => {
    const pathName = location.pathname

    for (let i = 0; i < tabsConfigValues.length; i++) {
      const item = tabsConfigValues[i]

      if (pathName === item.path) {
        return item.value
      }
    }

    return ''
  }, [location])

  return (
    <Box mt={'md'} className={'flex self-end min-w-0'}>
      <NavMenuBar value={tabsValue} onChange={onTabChange} tabs={tabs} />
    </Box>
  )
}
